import { Vector3 } from "core/Maths/math.vector";
import { RegisterClass } from "core/Misc/typeStore";
import { RewardGraphNode } from "../rewardGraphNode";
import { RewardGraphConnectionPointTypes } from "../rewardGraphConnectionPointTypes";
import { RewardGraphConnectionPoint } from "../rewardGraphConnectionPoint";
/**
 * Block used to apply a cross product between 2 vectors
 */
export class RewardCrossBlock extends RewardGraphNode {
    /**
     * @param name defines the block name
     */
    public constructor(name: string) {
        super(name);

        this.registerInput("left", RewardGraphConnectionPointTypes.Vector3);
        this.registerInput("right", RewardGraphConnectionPointTypes.Vector3);
        this.registerOutput("output", RewardGraphConnectionPointTypes.Vector3);
    }

    /**
     * Gets the current class name
     * @returns the class name
     */
    public override getClassName() {
        return "RewardCrossBlock";
    }

    /**
     * Gets the left operand input component
     */
    public get left(): RewardGraphConnectionPoint {
        return this._inputs[0];
    }

    /**
     * Gets the right operand input component
     */
    public get right(): RewardGraphConnectionPoint {
        return this._inputs[1];
    }

    /**
     * Gets the output component
     */
    public get output(): RewardGraphConnectionPoint {
        return this._outputs[0];
    }

    protected override _buildBlock() {
        if (!this.left.isConnected || !this.right.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }

        this.output._storedFunction = (state) => {
            const left = this.left.getConnectedValue(state);
            const right = this.right.getConnectedValue(state);

            switch (this.left.type) {
                case RewardGraphConnectionPointTypes.Vector3: {
                    return Vector3.Cross(left, right);
                }
            }

            return 0;
        };

        return this;
    }
}

RegisterClass("MELS.RewardCrossBlock", RewardCrossBlock);
